//
//  HEAVILY MODIFIED VERSION - Jason
//
angular.module('ngUpload', [])
  .directive('uploadSubmit', ["$parse", function($parse) {
    // Utility function to get the closest parent element with a given tag
    function getParentNodeByTagName(element, tagName) {
      element = angular.element(element);
      var parent = element.parent();
      tagName = tagName.toLowerCase();

      if ( parent && parent[0].tagName.toLowerCase() === tagName ) {
          return parent;
      } else {
          return !parent ? null : getParentNodeByTagName(parent, tagName);
      }
    }
    return {
      restrict: 'AC',
      link: function(scope, element, attrs) {
        scope.submitUploadElement = element;
        element.bind('click', function($event) {
          // prevent default behavior of click
          if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
          }

          if (element.attr('disabled')) { return; }
          var form = getParentNodeByTagName(element, 'form');
          form.attr("action", attrs.uploadSubmit);
          scope.$isUploading = true
          form.triggerHandler('submit');
          form[0].submit();
        });
      }
    };
  }])
  .directive('ngUpload', ["$log", "$parse", "$document",
    function ($log, $parse, $document) {
      var iframeID = 1;
      // Utility function to get meta tag with a given name attribute
      function getMetaTagWithName(name) {
        var head = $document.find('head');
        var match;

        angular.forEach(head.find('meta'), function(element) {
          if ( element.getAttribute('name') === name ) {
              match = element;
          }
        });

        return angular.element(match);
      }

      return {
        restrict: 'AC',
        link: function (scope, element, attrs) {
          // Give each directive instance a new id
          iframeID++;

          function setIsUploading(state) {
            if (!scope.$$phase) {
              scope.$apply(function() {
                scope.$isUploading = state;
              });
            } else {
              scope.$isUploading = state;
            }
          }

          var options = {};
          // Options (just 1 for now)
          // Each option should be prefixed with 'upload-options-' or 'uploadOptions'
          // {
          //    // add the Rails CSRF hidden input to form
          //    enableRailsCsrf: bool
          // }
          var fn = attrs.ngUpload ? $parse(attrs.ngUpload) : null;
          var loading = attrs.ngUploadLoading ? $parse(attrs.ngUploadLoading) : null;

          if ( attrs.hasOwnProperty( "uploadOptionsEnableRailsCsrf" ) ) {
              // allow for blank or true
              options.enableRailsCsrf = attrs.uploadOptionsEnableRailsCsrf != "false";
          }

          element.attr({
            'target': 'upload-iframe-' + iframeID,
            'method': 'post',
            'enctype': 'multipart/form-data',
            'encoding': 'multipart/form-data'
          });

          var iframe = angular.element(
            '<iframe name="upload-iframe-' + iframeID + '" ' +
            'border="0" width="0" height="0" ' +
            'style="width:0px;height:0px;border:none;display:none">'
          );

          // If enabled, add csrf hidden input to form
          if ( options.enableRailsCsrf ) {
            var input = angular.element("<input />");
              input.attr("class", "upload-csrf-token");
              input.attr("type", "hidden");
              input.attr("name", getMetaTagWithName('csrf-param').attr('content'));
              input.val(getMetaTagWithName('csrf-token').attr('content'));

            element.append(input);
          }
          element.after(iframe);

          setIsUploading(false);

          element.bind('submit', function uploadStart() {

            if (scope.$isUploading === true){
              // bind load after submit to prevent initial load triggering uploadEnd
              iframe.bind('load', uploadEnd);

              // safety to avoid any race conditions
              setTimeout(function(){
                // alernatively could have set scope.$isUploading = false in controller
                setIsUploading(false);
              }, 500);
            }

          });

          // Finish upload
         function uploadEnd() {
            // Get iframe body contents
            element.removeProp("action");
            var bodyContent = (iframe[0].contentDocument ||
              iframe[0].contentWindow.document).body;
            var content;
            try {
              content = angular.fromJson(bodyContent.innerText || bodyContent.textContent);
            } catch (e) {
              // Fall back to html if json parse failed
              content = bodyContent.innerHTML;
              $log.warn('Response is not valid JSON');
            }
            // if outside a digest cycle, execute the upload response function in the active scope
            // else execute the upload response function in the current digest
            if (!scope.$$phase) {
               scope.$apply(function () {
                   fn(scope, { content: content});
               });
            } else {
              fn(scope, { content: content});
            }
          }
        } // closes link
      }; // closes return
  }]);